import React from "react";
import { Link } from "react-router-dom";
import gif from "../../../assets/gif.gif";
const CallToAction = () => {
  const scrollHeader = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
  };
  return (
    <div className="csd-bottom-page-wrapper">
      <div className="row">
        <div className="col-12 col-md-9">
          <h4 className="title_text">
            Innovating the Future, One Solution at a Time
          </h4>
          <p className="contact_investers_para">
            At Soori Corporation, we don’t just develop software, we co-create
            the future with you. Harnessing cutting-edge technology and sharp
            industry insight, we transform your boldest ideas into seamless,
            customized solutions that empower your business to evolve, thrive,
            and lead in your industry.
          </p>
          <Link
            to="/connect-with-us"
            className="btn-md btn-dark border-0"
            onClick={() => scrollHeader()}
          >
            Innovate With Us
          </Link>
        </div>
        <div className="col-12 col-md-3">
          <div className="circle-gif">
            <img src={gif} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToAction;
